import {Injectable} from "@angular/core";
import {BrukerkontekstTilbyder} from "../../tjenester/BrukerkontekstTilbyder";
import {MatDialog} from "@angular/material/dialog";

/**
 * Sørger for at eventuelle åpne mat-dialoger blir lukket dersom bruker blir logget ut.
 */
@Injectable({providedIn: 'root'})
export class LukkMatDialogerVedUtlogging {

    constructor(private kontekstTilbyder: BrukerkontekstTilbyder, private matDialog: MatDialog) {
    }

    lukkMatDialogerVedUtlogging() {
        this.kontekstTilbyder.brukerLoggetUtSomStrøm().subscribe(() =>
          this.matDialog.closeAll());
    }
}
